export const UPDATE_WALLET_CHANNEL = "UpdateWalletChannel";
export const ISP_REQUEST_RECEIPT_FINISH_CHANNEL =
  "IspRequestReceiptFinishChannel";
export const ISP_RECEIPT_RESULT_FINISH_CHANNEL =
  "IspReceiptResultFinishChannel";
export const CHARGE_RESULTED_CHANNEL = "ChargeResultedChannel";
export const RECEIPT_CHARGING_PRELOTTERY_RESULT_CHANNEL =
  "ReceiptChargingPrelotteryResultChannel";
